import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useContext, useState, useRef, useCallback, useEffect, useMemo } from "react";
import ReactPlayer from "react-player";
import { ReactConfetti } from "../../chunks/react-confetti.js";
import { Star } from "flowbite-react-icons/solid";
import { formatCurrencyNumber, addZeroes, truncateString, getGTGLevel, getDonorLevel } from "../../chunks/utils.js";
import { LoggerContext } from "../../chunks/logger.context.js";
import './alerts.overlay.css';function getAlertsConfigFromURL(url) {
  const config = new URLSearchParams(url.search);
  const minAudio = Number.parseFloat(config.get("minAudio") ?? "1");
  const minDonation = Number.parseFloat(config.get("minDonation") ?? "1");
  const volume = Number.parseInt(config.get("volume") ?? "100", 10);
  const showAllDonations = (config.get("showAllDonations") ?? "no") === "yes";
  const incentivesEnabled = (config.get("incentives") ?? "no") === "yes";
  const audioEnabled = (config.get("sound") ?? "no") === "yes";
  const demoMode = (config.get("demoMode") ?? "no") === "yes";
  const type = (config.get("type") ?? "new") === "new" ? "new" : "regular";
  return {
    minAudio,
    minDonation,
    volume,
    showAllDonations,
    incentivesEnabled,
    audioEnabled,
    type,
    demoMode
  };
}
function Alert({
  level,
  gtg,
  name,
  amount,
  rewardClaims = [],
  rewards,
  showRewards,
  alwaysDisplaying = false
}) {
  let rewardsBlock;
  const showRewardsBlock = showRewards && rewardClaims.length;
  function getClaimedReward(rewardID) {
    return rewards.find((reward) => reward.id === rewardID);
  }
  if (showRewardsBlock)
    rewardsBlock = rewardClaims.slice(0, 1).map((claim) => {
      const reward = getClaimedReward(claim.reward_id);
      if (!reward) return null;
      return /* @__PURE__ */ jsxs("div", { className: "reward-content", children: [
        /* @__PURE__ */ jsx("div", { className: "reward-icon", children: /* @__PURE__ */ jsx(Star, {}) }),
        /* @__PURE__ */ jsxs("p", { className: "reward-message", children: [
          "Reward: ",
          reward.name
        ] })
      ] }, claim.reward_id);
    });
  return (
    // <div
    //   className={`alert_wrapper__${type}  cf ${!alwaysDisplaying ? `animated ${level}` : level} ${showRewardsBlock && 'reward'}`}
    // >
    /* @__PURE__ */ jsx(
      "div",
      {
        className: `alert_wrapper__${gtg.description.length > 0 ? "gifts" : "new"}  cf ${!alwaysDisplaying ? `animated ${level}` : level} ${showRewardsBlock && "reward"}`,
        children: gtg.description.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: "circle-lines", children: /* @__PURE__ */ jsxs("div", { className: "beams", children: [
            /* @__PURE__ */ jsx("div", { className: "beam beam-1" }),
            /* @__PURE__ */ jsx("div", { className: "beam beam-2" }),
            /* @__PURE__ */ jsx("div", { className: "beam beam-3" }),
            /* @__PURE__ */ jsx("div", { className: "beam beam-4" }),
            /* @__PURE__ */ jsx("div", { className: "beam beam-5" }),
            /* @__PURE__ */ jsx("div", { className: "beam beam-6" }),
            /* @__PURE__ */ jsx("div", { className: "beam beam-7" }),
            /* @__PURE__ */ jsx("div", { className: "beam beam-8" })
          ] }) }),
          /* @__PURE__ */ jsx("div", { className: "gifts__logo", children: /* @__PURE__ */ jsx("div", { className: "icon_bg", children: /* @__PURE__ */ jsx("div", { className: "icon", children: /* @__PURE__ */ jsx("span", { className: gtg.iconName }) }) }) }),
          /* @__PURE__ */ jsxs("div", { className: "donor", children: [
            /* @__PURE__ */ jsxs("p", { children: [
              name,
              " donated $",
              formatCurrencyNumber(addZeroes(Number(amount)))
            ] }),
            /* @__PURE__ */ jsx("div", { className: "type", children: gtg.size === "small" ? /* @__PURE__ */ jsx("div", { className: "type__wrap_short", children: /* @__PURE__ */ jsxs("p", { children: [
              /* @__PURE__ */ jsx("span", { children: "You helped unlock" }),
              " ",
              gtg.description
            ] }) }) : gtg.size === "big" ? /* @__PURE__ */ jsxs("div", { className: "type__wrap", children: [
              /* @__PURE__ */ jsx("p", { children: "You helped unlock" }),
              /* @__PURE__ */ jsx("p", { children: gtg.description })
            ] }) : "" })
          ] })
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: "donor", children: /* @__PURE__ */ jsxs(
            "div",
            {
              className: `donor__info ${!alwaysDisplaying ? `animated ${level}` : level}`,
              children: [
                /* @__PURE__ */ jsx(
                  ReactConfetti,
                  {
                    width: 500,
                    height: 93,
                    numberOfPieces: 50,
                    colors: [
                      "#8332a7",
                      "#1874dc",
                      "#64d0e4",
                      "#c0da07",
                      "#ffc32c",
                      "#490e67",
                      "#002856",
                      "#1eadc1",
                      "#75bc21",
                      "#ffb125",
                      "#c10f3a"
                    ]
                  }
                ),
                /* @__PURE__ */ jsxs("div", { className: "alert-content-wrapper", children: [
                  /* @__PURE__ */ jsxs("p", { className: "donation-message", children: [
                    truncateString(name, 15),
                    " donated $",
                    formatCurrencyNumber(addZeroes(Number(amount)))
                  ] }),
                  rewardsBlock
                ] })
              ]
            }
          ) }),
          /* @__PURE__ */ jsx("div", { className: "poof", children: /* @__PURE__ */ jsx("svg", { id: "c-like__icon", width: "93", height: "93", viewBox: "0 0 600 600", children: /* @__PURE__ */ jsxs("g", { className: "circle", children: [
            /* @__PURE__ */ jsx("g", { className: "circle1", id: "aqua1", children: /* @__PURE__ */ jsx(
              "ellipse",
              {
                ry: "30",
                rx: "30",
                cy: "35",
                cx: "35",
                strokeWidth: "0",
                stroke: "#000",
                fill: "#ddd"
              }
            ) }),
            /* @__PURE__ */ jsx("g", { className: "circle2", id: "aqua1", children: /* @__PURE__ */ jsx(
              "ellipse",
              {
                ry: "30",
                rx: "30",
                cy: "35",
                cx: "35",
                strokeWidth: "0",
                stroke: "#000",
                fill: "#ddd"
              }
            ) }),
            /* @__PURE__ */ jsx("g", { className: "circle3", id: "aqua1", children: /* @__PURE__ */ jsx(
              "ellipse",
              {
                ry: "30",
                rx: "30",
                cy: "35",
                cx: "565",
                strokeWidth: "0",
                stroke: "#000",
                fill: "#ddd"
              }
            ) }),
            /* @__PURE__ */ jsx("g", { className: "circle4", id: "aqua1", children: /* @__PURE__ */ jsx(
              "ellipse",
              {
                ry: "30",
                rx: "30",
                cy: "35",
                cx: "565",
                strokeWidth: "0",
                stroke: "#000",
                fill: "#ddd"
              }
            ) }),
            /* @__PURE__ */ jsx("g", { className: "circle5", id: "aqua1", children: /* @__PURE__ */ jsx(
              "ellipse",
              {
                ry: "30",
                rx: "30",
                cy: "565",
                cx: "565",
                strokeWidth: "0",
                stroke: "#000",
                fill: "#ddd"
              }
            ) }),
            /* @__PURE__ */ jsx("g", { className: "circle6", id: "aqua1", children: /* @__PURE__ */ jsx(
              "ellipse",
              {
                ry: "30",
                rx: "30",
                cy: "565",
                cx: "565",
                strokeWidth: "0",
                stroke: "#000",
                fill: "#ddd"
              }
            ) }),
            /* @__PURE__ */ jsx("g", { className: "circle7", id: "aqua1", children: /* @__PURE__ */ jsx(
              "ellipse",
              {
                ry: "30",
                rx: "30",
                cy: "565",
                cx: "30",
                strokeWidth: "0",
                stroke: "#000",
                fill: "#ddd"
              }
            ) }),
            /* @__PURE__ */ jsx("g", { className: "circle8", id: "aqua1", children: /* @__PURE__ */ jsx(
              "ellipse",
              {
                ry: "30",
                rx: "30",
                cy: "565",
                cx: "30",
                strokeWidth: "0",
                stroke: "#000",
                fill: "#ddd"
              }
            ) })
          ] }) }) }),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: `icon left ${!alwaysDisplaying ? `animated ${level}` : level}`,
              children: /* @__PURE__ */ jsx("span", { className: "icon__symbol" })
            }
          )
        ] })
      }
    )
  );
}
function AlertsOverlay({
  audioEnabled = false,
  donation,
  minAudio,
  minDonation,
  volume,
  incentivesEnabled,
  rewards = [],
  alertSoundURL,
  demoMode,
  alwaysDisplaying = false,
  className
}) {
  const logger = useContext(LoggerContext);
  const [isShowingOverlay, setIsShowingOverlay] = useState(!demoMode);
  const audioPlayer = useRef(null);
  let audioPlayerBlock = null;
  const showOverlay = useCallback(() => {
    setIsShowingOverlay(true);
  }, []);
  const handleAudioPlayerError = useCallback(
    (error) => {
      logger.error("Audio player error");
      logger.error(error);
    },
    [logger]
  );
  useEffect(() => {
    let timeout;
    if (isShowingOverlay && demoMode) {
      timeout = setTimeout(() => {
        setIsShowingOverlay(false);
      }, 9200);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [demoMode, isShowingOverlay]);
  const playing = useMemo(() => {
    if (!donation || !audioEnabled) return false;
    return parseFloat(donation.amount.value) >= minAudio;
  }, [audioEnabled, donation, minAudio]);
  const muted = useMemo(() => {
    if (!donation || !audioEnabled) return true;
    return parseFloat(donation.amount.value) < minAudio;
  }, [audioEnabled, donation, minAudio]);
  const currentVolume = useMemo(() => {
    if (!audioEnabled || !donation) return 0;
    const belowMinAudio = parseFloat(donation.amount.value) < minAudio;
    if (belowMinAudio) return 0;
    return volume / 100;
  }, [audioEnabled, donation, volume, minAudio]);
  useEffect(() => {
    if (donation) logger.log("donation", donation);
    else logger.log("No donation");
  }, [logger, donation]);
  if (!donation || Number.parseFloat(donation.amount.value) < minDonation)
    return null;
  if (alertSoundURL)
    audioPlayerBlock = /* @__PURE__ */ jsx(
      ReactPlayer,
      {
        ref: audioPlayer,
        url: alertSoundURL,
        playing,
        loop: false,
        volume: currentVolume,
        muted,
        onError: handleAudioPlayerError,
        height: "0",
        width: "0"
      }
    );
  let overlayBlock;
  if (!isShowingOverlay)
    overlayBlock = /* @__PURE__ */ jsx("div", { className: "demo-mode", children: /* @__PURE__ */ jsx(
      "button",
      {
        className: "alerts-demo-button",
        type: "button",
        onClick: showOverlay,
        children: "Show Alert"
      }
    ) }, "demo-mode");
  else
    overlayBlock = /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${className ? `playlive-alert ${className}` : "playlive-alert"} ${!alwaysDisplaying ? `animated ${donation.id}` : donation.id}`,
        children: [
          /* @__PURE__ */ jsx(
            Alert,
            {
              alwaysDisplaying,
              rewardClaims: donation.reward_claims ?? [],
              name: donation.donor_name,
              rewards,
              amount: donation.amount.value,
              showRewards: incentivesEnabled,
              level: getDonorLevel(donation.amount.value),
              gtg: getGTGLevel(donation.amount.value)
            }
          ),
          audioEnabled && playing && audioPlayerBlock
        ]
      },
      donation.id
    );
  return /* @__PURE__ */ jsx("div", { className: "alerts-overlay", children: overlayBlock });
}
export {
  AlertsOverlay,
  getAlertsConfigFromURL
};
//# sourceMappingURL=alerts.overlay.js.map
